module.exports = __webpack_public_path__ + "img/mechanical-arm.e827ff68.jpg";